import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { resolve } from '../../../utils/object/pathResolver';

const Notification = ({ fields, gateFlagValue, gatePath }) => {
  if (gatePath && !gateFlagValue) {
    return null;
  }
  return (
    <div className="vds-notification vds-notification--informational">
      <div className="vds-notification__inner">
        <div className="vds-notification__icon-container">
          <span className="vds-notification__icon-status"></span>
        </div>

        <div className="vds-notification__body">
          <div className="vds-notification__content">
            <div className="vds-notification__title-container">
              <Text tag="h2" className="vds-notification__title" field={fields.heading} />
            </div>

            <div className="vds-notification__message">
              <div className="vds-notification__message-main">
                <RichText field={fields.content} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const gatePath = props.fields?.appStateFlag?.value;
  return {
    gatePath,
    gateFlagValue: gatePath ? !!resolve(gatePath, state) : true,
  };
};

Notification.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.shape({ value: PropTypes.string }),
    content: PropTypes.shape({ value: PropTypes.string }),
    appStateFlag: PropTypes.shape({ value: PropTypes.string }),
  }),
  gateFlagValue: PropTypes.bool,
  gatePath: PropTypes.string,
};

export default connect(mapStateToProps)(Notification);
